import { AppState, } from '../types';

// /* ****************************************
//  * This Base State is served as default state for SEW App.
//  * It should replace default state in all reducers.
//  * *************************************** */
const baseState: AppState = {
  app: {
    config: {},
    theme: {},
  },
  navigation: {
    awardPanel: {
      isOpen: false,
    },
    consumerRatingPanel: {
      isOpen: false,
    },
    consumerReviewPanel: {
      isOpen: false,
    },
    expertRatingPanel: {
      isOpen: false,
    },
    expertReviewPanel: {
      isOpen: false,
    },
    globalOverlay: {
      isOpen: false,
      overlayHeader: '',
    },
  },
  vehicle: {
    bodyStyle: '',
    vehicleId: 0,
    makeId: 0,
    makeName: '',
    modelId: 0,
    modelName: '',
    trimId: 0,
    trimName: '',
    vehicleClass: '',
    yearId: 0,
    generationStartYear: '',
    generationEndYear: '',
    genericBodyStyle: ''
  },
  vehicleAward: {
    year: 0,
    make: '',
    model: '',
    awards: [],
  },
  consumerReviewAndRating: {
    numberOfReviews: 0,
    moreReviewsLink: '',
    consumerReviews: [
      {
        submissionDate: '',
        nickName: '',
        year: 0,
        title: '',
        text: '',
        overallRating: 0,
      }
    ],
    consumerRating: {
      overallRating: '',
      valueRating: '',
      qualityRating: '',
      reliabilityRating: '',
      performanceRating: '',
      comfortRating: '',
      stylingRating: '',
    },
  },
  expertReviewAndRating: {
    expertRating: {
      overallRating: '',
      comfortRating: '',
      stylingRating: '',
      valueRating: '',
      performanceRating: '',
    },
    editorOverview: {
      title: '',
      text: '',
    },
    pros: {
      title: '',
      text: '',
    },
    cons: {
      title: '',
      text: '',
    },
  },
  accountInfoData: {
    isExcludedFromYmmPrivacyPolicy: false,
    isOptedOutOfEWBacklink: false
  },
  errors: {
  },
};

export default baseState;
